// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__337ys","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__DgtyP"};